import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";
import React from "react";

import SendRequest from "hooks/useAxios";
import ArticleContext from "components/Singlearticle/context";
import { useParams } from "react-router-dom";
import "components/Singlearticle/singleArticle.scss";

export default function Article() {
  const { articleId } = useParams();

  const [singleArticle, setSingleArticle] = useState({
    title: "",
    // img1: laptop,
    description: "",
    bodyText: "",
    hashtags: [],
    files: [],
  });
  const [updater, setUpdater] = useState(false);
  useEffect(() => {
    SendRequest("getSinglePost", { postId: articleId }).then(({ data }) => {
      setSingleArticle(data.info);
    });
  }, [updater]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{singleArticle.title}</title>
      </Helmet>
      <div className="single-article-container">
        <ArticleContext title={singleArticle.title} description={singleArticle.description} bodyText={singleArticle.bodytxt} hashtags={singleArticle.hashtags} postId={articleId} singleArticle={singleArticle} files={[{ url: singleArticle.url }, ...singleArticle.files]} setUpdater={setUpdater}></ArticleContext>
      </div>
    </>
  );
}
